<div class="subject-box {{czyAktywny ? '' : 'is-inactive'}}">
    <em class="c-icon c-icon--{{przedmiot.imageSource}} icon"></em>
    <span>{{przedmiot.label}}</span>
</div>
